import { InputCheckBox, LabelPosition, TsrTooltip } from '../../../inputs';
import { IContextMenuCheckbox } from '../../interfaces/ContextMenu';
import React, { useEffect, useState } from 'react';
import '../styles.scss';
import { letterWidth } from '../../../consts/letterConsts';
import { CONTEXT_MENU_MAX_WIDTH } from '..';

function ContextCheckboxItem(props: IContextMenuCheckbox) {
    const { label, value, hasSeparator, disabled, visible, onCheckboxChange, onCloseMenu } = props;

    const [checkboxValue, setCheckboxValue] = useState(value);

    const changeValueHandler = () => {
        setCheckboxValue(prevValue => !prevValue);
        onCheckboxChange?.(!checkboxValue);
        onCloseMenu?.();
    };

    useEffect(() => {
        visible && setCheckboxValue(value);
    }, [value, visible]);

    const renderTooltip = label.length * letterWidth > CONTEXT_MENU_MAX_WIDTH;

    return renderTooltip ? (
        <TsrTooltip content={label}>
            <li className={'context-checkbox-item ' + (hasSeparator ? 'separator ' : '') + (disabled ? 'disabled ' : '')}>
                <InputCheckBox
                    value={checkboxValue}
                    onChange={changeValueHandler}
                    label={label}
                    labelPosition={LabelPosition.Right}
                    labelClassName={'noWrap'}
                    gap={6}
                    disabled={disabled}
                />
            </li>
        </TsrTooltip>
    ) : (
        <li className={'context-checkbox-item ' + (hasSeparator ? 'separator ' : '') + (disabled ? 'disabled ' : '')}>
            <InputCheckBox
                value={checkboxValue}
                onChange={changeValueHandler}
                label={label}
                labelPosition={LabelPosition.Right}
                labelClassName={'noWrap'}
                gap={6}
                disabled={disabled}
            />
        </li>
    );
}

export default ContextCheckboxItem;
